// Display format of a person's name, whatever casing it was typed with: the first name with a
// capital at the start of each part ("jean-pierre" → "Jean-Pierre"), the last name in capitals
// ("decimus" → "DECIMUS"). Display only: inputs, searches and payloads keep the stored value.

const toText = (value) => (typeof value === "string" ? value.trim().replace(/\s+/g, " ") : "");

export const formatFirstname = (firstname) =>
    toText(firstname)
        .toLocaleLowerCase("fr-FR")
        .replace(/(^|[\s\-'’])(\p{L})/gu, (match, separator, letter) => separator + letter.toLocaleUpperCase("fr-FR"));

export const formatLastname = (lastname) => toText(lastname).toLocaleUpperCase("fr-FR");

/** "Beatrice DECIMUS"; one of the two may be missing. */
export const formatFullName = (firstname, lastname) =>
    [formatFirstname(firstname), formatLastname(lastname)].filter(Boolean).join(" ");
